// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 700.98px) {
  .about {
    color: rgb(255, 255, 255);
    width: 100%;
    /* top | right | bottom | left */
    padding: 2px 20px 1px 20px;
    display: block;
    align-items: center;
    justify-content: center;
  }
  .about .text_about {
    text-align: center;
  }
  .about .logos {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .about .iconEkeme_about {
    width: 200px;
  }
  .about .logoKSPER_about {
    width: 200px;
  }
  .about .text_body {
    font-size: large;
    padding-top: 70px;
    text-align: center;
  }
  .about .modal_terminos {
    color: black;
  }
  .about .text_terminos {
    color: black;
  }
  .about .termino_condiciones {
    display: flex;
    justify-content: center;
  }
  .about .termino_condiciones .bt_terminos {
    background: linear-gradient(180deg, rgb(74, 128, 255) 0%, rgb(0, 44, 139) 77%, rgb(48, 145, 248) 100%);
    color: #eaecee;
    font-family: "Saira", "Lucida Console", "Courier New", "monospace";
    font-size: 14pt;
    width: 300px;
  }
}
@media (max-width: 700.97px) {
  .about {
    color: white;
    width: 100%;
    /* top | right | bottom | left */
    padding: 2px 20px 1px 20px;
    display: block;
    align-items: center;
    justify-content: center;
  }
  .about .text_about {
    text-align: center;
  }
  .about .logos {
    display: grid;
    align-items: center;
    justify-content: center;
  }
  .about .iconEkeme_about {
    width: 200px;
  }
  .about .logoKSPER_about {
    padding-top: 30px;
    width: 200px;
  }
  .about .text_body {
    font-size: large;
    padding-top: 70px;
    text-align: center;
  }
  .about .termino_condiciones {
    padding-top: 80px;
    display: flex;
    justify-content: center;
  }
  .about .termino_condiciones .bt_terminos {
    background: linear-gradient(180deg, rgb(74, 128, 255) 0%, rgb(0, 44, 139) 77%, rgb(48, 145, 248) 100%);
    color: #eaecee;
    font-family: "Saira", "Lucida Console", "Courier New", "monospace";
    font-size: 14pt;
    width: 300px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Estaticas/About/about.scss"],"names":[],"mappings":"AAAA;EACE;IACE,yBAAA;IACA,WAAA;IACA,gCAAA;IACA,0BAAA;IACA,cAAA;IACA,mBAAA;IACA,uBAAA;EACF;EACE;IACE,kBAAA;EACJ;EAEE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;EAAJ;EAEE;IACE,YAAA;EAAJ;EAEE;IACE,YAAA;EAAJ;EAGE;IACE,gBAAA;IACA,iBAAA;IACA,kBAAA;EADJ;EAIE;IACE,YAAA;EAFJ;EAKE;IACE,YAAA;EAHJ;EAME;IACE,aAAA;IACA,uBAAA;EAJJ;EAQI;IACE,sGAAA;IAME,cAAA;IACA,kEAAA;IACA,eAAA;IACA,YAAA;EAXR;AACF;AAkBE;EACE;IACE,YAAA;IACA,WAAA;IACA,gCAAA;IACA,0BAAA;IACA,cAAA;IACA,mBAAA;IACA,uBAAA;EAhBJ;EAkBI;IACE,kBAAA;EAhBN;EAmBI;IACC,aAAA;IACA,mBAAA;IACA,uBAAA;EAjBL;EAoBI;IACE,YAAA;EAlBN;EAoBI;IACE,iBAAA;IACA,YAAA;EAlBN;EAqBI;IACE,gBAAA;IACA,iBAAA;IACA,kBAAA;EAnBN;EAuBI;IACE,iBAAA;IACA,aAAA;IACA,uBAAA;EArBN;EAuBM;IACE,sGAAA;IAME,cAAA;IACA,kEAAA;IACA,eAAA;IACA,YAAA;EA1BV;AACF","sourcesContent":["@media (min-width: 700.98px) { \n  .about {\n    color: rgb(255, 255, 255);\n    width: 100%;\n    /* top | right | bottom | left */\n    padding: 2px 20px 1px 20px;\n    display: block;\n    align-items: center;\n    justify-content: center;\n    \n    .text_about {\n      text-align: center;\n    }\n    \n    .logos {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n    .iconEkeme_about {\n      width: 200px;\n    }\n    .logoKSPER_about {\n      width: 200px;\n    }\n    \n    .text_body {\n      font-size: large;\n      padding-top: 70px;\n      text-align: center;\n      \n    }\n    .modal_terminos{\n      color : black;\n    }\n\n    .text_terminos{\n      color: black;\n    }\n    \n    .termino_condiciones {\n      display: flex;\n      justify-content: center;\n\n      \n      \n      .bt_terminos {\n        background: linear-gradient(\n          180deg,\n          rgb(74, 128, 255) 0%,\n          rgb(0, 44, 139) 77%,\n          rgb(48, 145, 248) 100%\n          );\n          color: #eaecee;\n          font-family: \"Saira\", \"Lucida Console\", \"Courier New\", \"monospace\";\n          font-size: 14pt;\n          width: 300px;\n        }\n      }\n    }\n    \n  }\n\n\n  @media (max-width: 700.97px) { \n    .about{\n      color: white;\n      width: 100%;\n      /* top | right | bottom | left */\n      padding: 2px 20px 1px 20px;\n      display: block;\n      align-items: center;\n      justify-content: center;\n      \n      .text_about {\n        text-align: center;\n      }\n      \n      .logos {\n       display:grid;\n       align-items: center;\n       justify-content: center;\n        \n      }\n      .iconEkeme_about {\n        width: 200px;\n      }\n      .logoKSPER_about {\n        padding-top: 30px;\n        width: 200px;\n      }\n      \n      .text_body {\n        font-size: large;\n        padding-top: 70px;\n        text-align: center;\n        \n      }\n      \n      .termino_condiciones {\n        padding-top: 80px;\n        display: flex;\n        justify-content: center;\n        \n        .bt_terminos {\n          background: linear-gradient(\n            180deg,\n            rgb(74, 128, 255) 0%,\n            rgb(0, 44, 139) 77%,\n            rgb(48, 145, 248) 100%\n            );\n            color: #eaecee;\n            font-family: \"Saira\", \"Lucida Console\", \"Courier New\", \"monospace\";\n            font-size: 14pt;\n            width: 300px;\n          }\n        }\n      }\n      \n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
